import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", "aria-label", "disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/icons/bell.svg",
  alt: "",
  class: "w-4 h-4 flex-shrink-0"
}, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "px-2 text-xs text-gray-500",
  role: "status"
}
const _hoisted_5 = {
  key: 1,
  class: "px-2 text-xs text-red-600",
  role: "status"
}
const _hoisted_6 = {
  key: 0,
  class: "fixed top-20 right-4 z-50 w-80 max-w-full bg-white border border-gray-200 rounded-lg shadow-lg p-4",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-800" }, "Новое сообщение от клиента", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-600" }, "В чатах есть непрочитанные сообщения.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["flex w-full items-center space-x-2 text-left text-sm text-gray-600 p-2 rounded-md hover:bg-gray-200 focus:bg-gray-200", { 'justify-center': _ctx.collapsed }]),
      title: _ctx.buttonTitle,
      "aria-label": _ctx.buttonTitle,
      disabled: _ctx.pushBusy,
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.enableNotifications && _ctx.enableNotifications(...args)), ["stop"]))
    }, [
      _hoisted_2,
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.buttonTitle), 1))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    (_ctx.unavailable && !_ctx.collapsed)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Уведомления чатов временно недоступны "))
      : _createCommentVNode("", true),
    (_ctx.pushError && !_ctx.collapsed)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Не удалось подключить уведомления при закрытой вкладке. Нажмите кнопку, чтобы повторить. "))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.toastVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "float-right text-gray-500 px-2",
              "aria-label": "Закрыть уведомление",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideToast && _ctx.hideToast(...args)))
            }, " × "),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("button", {
              type: "button",
              class: "mt-3 text-sm font-medium text-blue-600 hover:underline",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMessenger && _ctx.openMessenger(...args)))
            }, " Открыть чаты ")
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}